import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { ScreensContext } from '../contexts/screensContext';
import AgeVerificationScreen from '../components/24ua-lm-spl-test/age-verification-screen';
import NotAllowedScreen from '../components/24ua-lm-spl-test/not-allowed-screen';
import EngagementScreen from '../components/24ua-lm-spl-test/engagement-screen';
import HomeScreen from '../components/24ua-lm-spl-test/home-screen';
import ReviewFlowScreen from '../components/24ua-lm-spl-test/review-flow-screen';
import AuthorityScreen from '../common/authority-screen';
import AllBrandsScreen from '../common/all-brands-screen';
import BrandLineScreen from '../common/brand-line-screen';
import ErrorScreen from '../components/lm-d-s/errorScreen';
import AuthFlowWrapper from '../common/lm-1test-registration-flow-wrapper';
import CookieConsentFlowWrapper from '../common/lm-1test-cookie-consent-flow-wrapper';
import useScreenHistory from '../hooks/useScreenHistory';

const PROJECT_ID = '24UA-LM-Spl-test';

const LMSplTest = () => {
  const { screenNumber, setScreenNumber, historyState, updateHistoryState } =
    useScreenHistory({
      initialScreen: 10,
      initialState: { brandLine: 'lm' }
    });
  const brandLine = historyState.brandLine || 'lm';
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);

  const { init } = useContext(DataLayerEventContext);

  useEffect(() => {
    init(PROJECT_ID);
  }, [init]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  const getScreen = (number, cb) => {
    switch (number) {
      case 10:
      case 0: {
        return (
          <>
            <EngagementScreen
              handleFinish={() => setScreenNumber(0.5)}
              isActive={number === 0}
            />
            {number === 10 && (
              <AgeVerificationScreen
                handleConfirm={() => setScreenNumber(0)}
                handleDecline={() => setScreenNumber(11)}
              />
            )}
          </>
        );
      }
      case 11: {
        return <NotAllowedScreen />;
      }
      case 0.5: {
        return (
          <AuthFlowWrapper
            withoutCookieBanner
            onComplete={() => setScreenNumber(1, true)}
          />
        );
      }
      case 1: {
        return (
          <HomeScreen
            handleToReview={() => setScreenNumber(2)}
            handleToAuthority={() => setScreenNumber(3)}
            handleToAllBrands={() => setScreenNumber(4)}
          />
        );
      }
      case 2: {
        return <ReviewFlowScreen setScreenNumber={setScreenNumber} />;
      }
      case 3: {
        return (
          <AuthorityScreen
            setScreenNumber={cb}
            handleBackToMenu={() => setScreenNumber(1, true)}
            menuButtonText="Назад"
            withoutReviewButton
          />
        );
      }
      case 4: {
        return (
          <AllBrandsScreen
            setScreenNumber={setScreenNumber}
            setBrandLine={(brand) =>
              setScreenNumber(5, false, { brandLine: brand })
            }
            handleBackButton={() => setScreenNumber(1, true)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      case 5: {
        return (
          <BrandLineScreen
            brandId={brandLine}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(4, true)}
            nextButtonClick={() => setScreenNumber(1)}
            withoutHeader
            historyState={historyState}
            updateHistoryState={updateHistoryState}
          />
        );
      }
      default: {
        return <ErrorScreen setScreenNumber={cb} />;
      }
    }
  };

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      <CookieConsentFlowWrapper>
        {getScreen(screenNumber, setScreenNumber)}
      </CookieConsentFlowWrapper>
    </ScreensContext.Provider>
  );
};

export default LMSplTest;
